<template>
    <div class="page">
        <div v-if="brand == 'COTTI'" class="tip">正在打开“库迪咖啡”...</div>
        <div v-else class="tip">正在打开“茶猫”...</div>
        <van-button :loading="isWaiting" loading-text="正在打开小程序" :style="isWaiting ? {opacity: 0.6} : {}" :class="brand == 'COTTI' ? 'open-action' : 'open-action-tc'" @click="toWechat()">打开小程序</van-button>
    </div>
  </template>
  
  <script>
  import { getWeChatScheme } from "../../api";
  export default {
    data() {
      return {
        bgUrl: "",
        btnUrl: "",
        appletUrl:"",
        brand: this.$config.env.VUE_APP_BRAND,
        isWaiting: false
      };
    },
    created() {
      this.$sensors.track("jumpMiniProgram_page_view");
    },
    mounted() {
        this.isWaiting = false
        this.toWechat()
    },
    methods: {
      toWechat() {
        if (this.$route.query.path) {
          // // 过滤掉path属性并拼接其他key=value参数
          const queryParams = Object.keys(this.$route.query)
            .filter(key => key !== 'path')
            .map(key => `${key}=${this.$route.query[key]}`)
            .join('&');
          this.openApplet(this.$route.query.path + ( queryParams ? '?' + queryParams : ''))
        } else {
          this.openApplet('/pages/index/index')
        }
      },
      queryURLParams(URL) { // 取url参数
        if (URL.indexOf("?") !== -1) {
          let url = URL.split("?")[1];
          let obj = {}; // 声明参数对象
          let arr = url.split("&"); // 以&符号分割为数组
          for (let i = 0; i < arr.length; i++) {
            let arrNew = arr[i].split("="); // 以"="分割为数组
            obj[arrNew[0]] = arrNew[1];
          }
          return obj;
        }
      },
        openApplet(appletUrl) {
            this.$sensors.track("jumpMiniProgram_btn_click");
            this.isWaiting = true
            try {
                const path = appletUrl.split('?')[0]
                const query = appletUrl.split('?')[1] || ''
                getWeChatScheme({ path, query }).then(res => {
                if (res.data.scheme) {
                    location.href = res.data.scheme;
                    this.isWaiting = false
                } else {
                    this.$toast({ message: "打开小程序失败，请确认已安装微信" });
                    this.isWaiting = false
                }
                })
            }catch (e) {
                this.$toast({ message: "打开小程序失败，请确认已安装微信" });
                this.isWaiting = false
            }
        },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .page {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .tip {
        font-weight: 400;
        font-size: 24px;
        color: #000000;
    }
    .open-action{
        background: #A52337;
        width: 320px;
        height: 80px;
        border-radius: 46px;
        box-shadow: 0px 2px 4px 0px rgba(143,92,92,0.12);
        font-size: 28px;
        font-weight: 600;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        outline: none;
        margin-top: 146px;
        // margin-bottom: 24px;
    }
    .open-action-tc{
        background: #9FCC0C;
        width: 320px;
        height: 80px;
        border-radius: 46px;
        box-shadow: 0px 2px 4px 0px rgba(143,92,92,0.12);
        font-size: 28px;
        font-weight: 600;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        outline: none;
        // margin-bottom: 24px;
        margin-top: 146px;
    }
    .bj {
      width: 100%;
      height: 100vh;
      display: block;
    }
    .btn {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  </style>